import _ from "lodash";
import { LogBox, Platform } from "react-native";

export function ignoreLogs() {
  LogBox.ignoreAllLogs();

  console.debug = _.noop;
  console.error = _.noop;
  console.group = _.noop;
  console.groupCollapsed = _.noop;
  console.groupEnd = _.noop;
  console.info = _.noop;
  console.log = _.noop;
  console.table = _.noop;
  console.trace = _.noop;
  console.warn = _.noop;

  // These are not available in React Native:
  if (Platform.OS === "web") {
    console.assert = _.noop;
    console.clear = _.noop;
    console.count = _.noop;
    console.countReset = _.noop;
    console.dir = _.noop;
    console.dirxml = _.noop;
    console.time = _.noop;
    console.timeEnd = _.noop;
    console.timeLog = _.noop;
    console.profile = _.noop;
    console.profileEnd = _.noop;
    console.timeStamp = _.noop;
  }
}
